import React from "react";

const Image = ({ userImage, name }) => {
  return (
    <div className="imgBlock">
      <div>
        {userImage == "" || userImage === null ? (
          <div>{name.substring(0, 1).toUpperCase()}</div>
        ) : (
          <>
            <img src={userImage} alt="" />
          </>
        )}
      </div>
    </div>
  );
};

export default Image;
